import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './Award.styles';

export interface IconProps extends WithStyles<typeof styles> {
  color?: string;
}

const AwardIconComponent: FC<IconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path
        d="M5.94596 9.32448L2.77533 3.65076C2.41076 2.99837 2.22847 2.67217 2.25919 2.4051C2.286 2.17209 2.40975 1.96116 2.60008 1.82409C2.81824 1.66699 3.19191 1.66699 3.93926 1.66699H5.80161C6.07935 1.66699 6.21823 1.66699 6.34279 1.7071C6.45302 1.7426 6.55463 1.80067 6.64116 1.87763C6.73895 1.96459 6.80944 2.08425 6.95041 2.32355L10.0001 7.50033L13.0498 2.32355C13.1907 2.08425 13.2612 1.96459 13.359 1.87763C13.4455 1.80067 13.5472 1.7426 13.6574 1.7071C13.7819 1.66699 13.9208 1.66699 14.1986 1.66699H16.0609C16.8083 1.66699 17.1819 1.66699 17.4001 1.82409C17.5904 1.96116 17.7142 2.17209 17.741 2.4051C17.7717 2.67217 17.5894 2.99837 17.2248 3.65076L14.0542 9.32447M8.75009 11.667L10.0001 10.8337V15.0003M8.95842 15.0003H11.0418M13.8303 9.08683C15.9456 11.2022 15.9456 14.6318 13.8303 16.7472C11.7149 18.8625 8.28527 18.8625 6.16992 16.7472C4.05459 14.6318 4.05459 11.2022 6.16992 9.08683C8.28526 6.97149 11.7149 6.97149 13.8303 9.08683Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AwardIcon = withStyles(styles)(AwardIconComponent);
